import axios from "axios";
import Config from "../config";

const updateGroup = data => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/group/update",
        data
    });
};

export default updateGroup;
